export default function toNumber(n) {
  if (n === null || n === undefined) return n;
  return Number(n);
}
